import { ActKc2GroupTypeEnum, type ActKc2ListItemData } from 'gql/graphql';
import type { TGroupedData } from 'pages/Project/Common/ActsKC2ListContainer/helpers';
import { Button, IconKebab, ContextMenu } from 'uikit';

import type { ICellRendererParams } from 'ag-grid-community';
import * as R from 'ramda';
import React, { useCallback, useMemo, useRef, useState } from 'react';

interface TMenuCellRenderer extends ICellRendererParams<TGroupedData<ActKc2ListItemData, ActKc2GroupTypeEnum>> {
    handleDeleteGroup?: (id: number) => void;
    handlerOpenEditGroup?: (id: number) => void;
}

export const MenuCellRenderer = (props: TMenuCellRenderer) => {
    const { data, handleDeleteGroup, handlerOpenEditGroup } = props;

    const ref = useRef(null);
    const [isContextOpen, setIsContextOpen] = useState<boolean>(false);

    const onContextMenuButtonClick = useCallback((evt) => {
        evt.stopPropagation();
        setIsContextOpen(R.not);
    }, []);

    const groupKebabMenuItems = useMemo(
        () => [
            {
                label: 'Редактировать',
                action: () => {
                    handlerOpenEditGroup?.(data?.groupId);
                },
            },
            {
                label: 'Удалить',
                action: () => {
                    handleDeleteGroup?.(data?.groupId);
                },
            },
        ],
        [data?.groupId, handleDeleteGroup, handlerOpenEditGroup],
    );

    const onGroupKebabMenuClick = useCallback(
        (item) => () => {
            const { action } = item;

            action?.();
        },
        [],
    );

    if (data?.isGroup && data?.groupType === ActKc2GroupTypeEnum.Custom) {
        return (
            <>
                <Button
                    ref={ref}
                    onClick={onContextMenuButtonClick}
                    iconLeft={IconKebab}
                    onlyIcon
                    view="clear"
                    size="xs"
                />
                <ContextMenu
                    isOpen={isContextOpen}
                    offset={8}
                    items={groupKebabMenuItems}
                    getItemLabel={R.prop('label')}
                    anchorRef={ref}
                    direction="downStartLeft"
                    getItemOnClick={onGroupKebabMenuClick}
                    onClickOutside={onContextMenuButtonClick}
                />
            </>
        );
    }

    return '';
};

MenuCellRenderer.displayName = 'MenuCellRenderer';
